import styled from 'styled-components';
import Text12 from '@sdk/components/ui/typography/Text12';
import Row from '@sdk/components/ui/spacing/Row';

export const ExampleLabel = styled(Text12)`
  margin-left: 5px;
`;

export const ExampleTooltipActivator = styled(Row)`
  cursor: pointer;
  align-self: flex-start;

  &:not(:hover) {
    opacity: 0.65;
  }
`;
